module.exports = "<div class=\"vclip_sports\"><div class=\"vclip_player\"><div class=\"vclip_box\" id=\"_vClipBox\"></div></div><a href=\"{{:link}}\" class=\"link_item\" target=\"_blank\" title=\"새창열림\"><div class=\"wrap_cont\"> <strong class=\"tit_vclip\">{{:desc}}</strong><div class=\"subinfo_vclip\"> <span class=\"txt_play\"><span class=\"ico_sports ico_video\">재생횟수</span>{{:hit}}</span> <span class=\"txt_date\">{{:date}}</span></div></div></a></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sports/core/videoClip/clip.hbs
 ** module id = 6
 ** module chunks = 0
 **/